export default __webpack_public_path__ + "img/way-of-life.webp";